// A font request can fail during network startup while cached JS still works.
// Retry just the font; never reload an active customer's page to fix typography.
export async function recoverKioskFont({ fonts = document.fonts, Font = window.FontFace,
    wait = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) {
    if (!fonts || !Font) return false;
    const loaded = () => [...fonts].some(face => face.family.replace(/['"]/g, '') === 'Inter' && face.status === 'loaded');
    for (const [attempt, delay] of [15000, 60000, 300000].entries()) {
        await wait(delay);
        if (loaded()) return true;
        const url = `${process.env.PUBLIC_URL || ''}/fonts/Inter.ttf?retry=${attempt + 1}`;
        const face = new Font('Inter', `url(${JSON.stringify(url)})`, { weight: '100 900', style: 'normal', display: 'swap' });
        try {
            await face.load();
            fonts.add(face);
            return true;
        } catch { /* Next bounded retry; system fallback remains usable. */ }
    }
    return false;
}
